import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/logo.png'
import _imports_1 from '../assets/img/title.png'
import _imports_2 from '../assets/img/start_btn.png'
import _imports_3 from '../assets/img/agree_icon.png'
import _imports_4 from '../assets/img/foot_text.png'
import _imports_5 from '../assets/img/chuan.png'
import _imports_6 from '../assets/img/user_icon.png'
import _imports_7 from '../assets/img/seal.png'
import _imports_8 from '../assets/img/back.png'
import _imports_9 from '../assets/img/share_btn.png'
import _imports_10 from '../assets/img/share_care_pb.png'
import _imports_11 from '../assets/img/share_care_gt.png'
import _imports_12 from '../assets/img/share_care_fx.png'
import _imports_13 from '../assets/img/share_care_lt.png'
import _imports_14 from '../assets/img/arrow.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-3b1f453a")

_pushScopeId("data-v-3b1f453a")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = {
  key: 0,
  class: "home"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "logo",
  alt: "封面新闻"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "title",
  alt: "逆时光之流"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 我同意封面新闻客户端使用我的历史数据用以生成《封面新闻2023年用户年度报告》 ")
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "footer" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_4,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(" 数据截止于2023年12月 ")
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "封面新闻",
  class: "logo"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: _imports_5,
  class: "ship",
  alt: "船"
}, null, -1)
const _hoisted_9 = {
  class: "petal",
  ref: "petal"
}
const _hoisted_10 = { class: "swiper" }
const _hoisted_11 = { class: "swiper-wrapper" }
const _hoisted_12 = {
  key: 0,
  class: "swiper-slide"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Hi ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("，")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("今天是你与封面新闻相遇的第")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("天。")
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("年")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("月")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("日，")
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("你关心的")
const _hoisted_23 = /*#__PURE__*/_createVNode("span", null, "第一篇新闻", -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_25 = { key: 2 }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("《")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("》，")
const _hoisted_28 = { key: 3 }
const _hoisted_29 = {
  key: 1,
  class: "swiper-slide"
}
const _hoisted_30 = /*#__PURE__*/_createVNode("p", null, "2023年", -1)
const _hoisted_31 = /*#__PURE__*/_createTextVNode("封面新闻陪伴了你 ")
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" 天")
const _hoisted_33 = /*#__PURE__*/_createVNode("p", null, "这一年", -1)
const _hoisted_34 = /*#__PURE__*/_createTextVNode("你打开了封面新闻 ")
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" 次")
const _hoisted_36 = /*#__PURE__*/_createVNode("p", null, "你对世界的好奇心", -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode("超过了 ")
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" 的封面网友")
const _hoisted_39 = { class: "swiper-slide" }
const _hoisted_40 = /*#__PURE__*/_createVNode("p", null, "2023年", -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("p", null, "我们一起见证了年度新闻：", -1)
const _hoisted_42 = { class: "swiper-slide" }
const _hoisted_43 = /*#__PURE__*/_createVNode("p", null, "2023年", -1)
const _hoisted_44 = /*#__PURE__*/_createVNode("p", null, "我们一起见证了年度新闻：", -1)
const _hoisted_45 = { class: "swiper-slide" }
const _hoisted_46 = /*#__PURE__*/_createVNode("p", null, "2023年", -1)
const _hoisted_47 = /*#__PURE__*/_createVNode("p", null, "我们一起见证了年度新闻：", -1)
const _hoisted_48 = { class: "swiper-slide" }
const _hoisted_49 = /*#__PURE__*/_createVNode("p", null, "2023年", -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("p", null, "我们一起见证了年度新闻：", -1)
const _hoisted_51 = { class: "swiper-slide" }
const _hoisted_52 = /*#__PURE__*/_createVNode("p", null, "2023年", -1)
const _hoisted_53 = /*#__PURE__*/_createVNode("p", null, "我们一起见证了年度新闻：", -1)
const _hoisted_54 = {
  key: 2,
  class: "swiper-slide"
}
const _hoisted_55 = /*#__PURE__*/_createVNode("p", null, "2023年，", -1)
const _hoisted_56 = /*#__PURE__*/_createVNode("p", null, "你积极与封面新闻进行互动。", -1)
const _hoisted_57 = { key: 0 }
const _hoisted_58 = /*#__PURE__*/_createTextVNode("阅读 ")
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" 篇新闻，")
const _hoisted_60 = { key: 1 }
const _hoisted_61 = /*#__PURE__*/_createTextVNode("观看 ")
const _hoisted_62 = /*#__PURE__*/_createTextVNode(" 场直播，")
const _hoisted_63 = { key: 2 }
const _hoisted_64 = /*#__PURE__*/_createTextVNode("转发 ")
const _hoisted_65 = /*#__PURE__*/_createTextVNode(" 篇内容，")
const _hoisted_66 = { key: 3 }
const _hoisted_67 = /*#__PURE__*/_createTextVNode("点赞 ")
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" 次。")
const _hoisted_69 = { key: 4 }
const _hoisted_70 = /*#__PURE__*/_createTextVNode("发布 ")
const _hoisted_71 = /*#__PURE__*/_createTextVNode(" 条动态内容，")
const _hoisted_72 = { key: 5 }
const _hoisted_73 = /*#__PURE__*/_createTextVNode("发表 ")
const _hoisted_74 = /*#__PURE__*/_createTextVNode(" 条评论，")
const _hoisted_75 = { key: 6 }
const _hoisted_76 = /*#__PURE__*/_createTextVNode("收获 ")
const _hoisted_77 = /*#__PURE__*/_createTextVNode(" 个粉丝，")
const _hoisted_78 = /*#__PURE__*/_createTextVNode(" 次点赞。")
const _hoisted_79 = {
  key: 3,
  class: "swiper-slide"
}
const _hoisted_80 = /*#__PURE__*/_createVNode("p", null, "你最常访问的频道是", -1)
const _hoisted_81 = { class: "channel" }
const _hoisted_82 = /*#__PURE__*/_createVNode("p", null, "时光匆匆流过", -1)
const _hoisted_83 = /*#__PURE__*/_createVNode("p", null, "在五彩缤纷的世界里", -1)
const _hoisted_84 = /*#__PURE__*/_createVNode("p", null, "封面新闻陪你见证了精彩，留住了记忆。", -1)
const _hoisted_85 = {
  key: 4,
  class: "swiper-slide"
}
const _hoisted_86 = /*#__PURE__*/_createVNode("p", null, "2023年", -1)
const _hoisted_87 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode("与封面新闻"),
  /*#__PURE__*/_createVNode("span", null, "互动值最高"),
  /*#__PURE__*/_createTextVNode("的十位“亲密好友”是")
], -1)
const _hoisted_88 = { class: "user-top" }
const _hoisted_89 = /*#__PURE__*/_createVNode("div", { class: "avatar" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_6,
    alt: ""
  })
], -1)
const _hoisted_90 = /*#__PURE__*/_createVNode("p", { style: {"font-size":"2.6vw"} }, "(Tips：排名不分先后哦）", -1)
const _hoisted_91 = {
  key: 5,
  class: "swiper-slide"
}
const _hoisted_92 = /*#__PURE__*/_createTextVNode("你和 ")
const _hoisted_93 = /*#__PURE__*/_createTextVNode(" 的人一样")
const _hoisted_94 = /*#__PURE__*/_createVNode("p", null, "最喜欢在", -1)
const _hoisted_95 = /*#__PURE__*/_createVNode("p", null, "打开封面。", -1)
const _hoisted_96 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_97 = { key: 0 }
const _hoisted_98 = { key: 1 }
const _hoisted_99 = { key: 2 }
const _hoisted_100 = { key: 3 }
const _hoisted_101 = { key: 4 }
const _hoisted_102 = { key: 5 }
const _hoisted_103 = { key: 6 }
const _hoisted_104 = { key: 7 }
const _hoisted_105 = { key: 8 }
const _hoisted_106 = { key: 9 }
const _hoisted_107 = { key: 10 }
const _hoisted_108 = { key: 11 }
const _hoisted_109 = {
  key: 6,
  class: "swiper-slide"
}
const _hoisted_110 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode("是你今年"),
  /*#__PURE__*/_createVNode("span", null, "最早阅读"),
  /*#__PURE__*/_createTextVNode("的时刻，")
], -1)
const _hoisted_111 = /*#__PURE__*/_createVNode("p", null, "晨风拂过的世界，我陪你看过了。", -1)
const _hoisted_112 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_113 = { key: 0 }
const _hoisted_114 = { key: 1 }
const _hoisted_115 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode("是你今年"),
  /*#__PURE__*/_createVNode("span", null, "最晚阅读"),
  /*#__PURE__*/_createTextVNode("的时刻，")
], -1)
const _hoisted_116 = /*#__PURE__*/_createVNode("p", null, "月落云淡的夜晚，陪你入眠的是哪篇新闻？", -1)
const _hoisted_117 = {
  key: 7,
  class: "swiper-slide"
}
const _hoisted_118 = /*#__PURE__*/_createVNode("p", null, "在过去的一年里，", -1)
const _hoisted_119 = /*#__PURE__*/_createTextVNode("你参加了 ")
const _hoisted_120 = /*#__PURE__*/_createTextVNode(" 次互动活动，")
const _hoisted_121 = /*#__PURE__*/_createVNode("p", null, "有趣有盼，不负心中热爱。", -1)
const _hoisted_122 = /*#__PURE__*/_createVNode("p", null, "这一年，", -1)
const _hoisted_123 = /*#__PURE__*/_createTextVNode("你共获得了 ")
const _hoisted_124 = { key: 0 }
const _hoisted_125 = /*#__PURE__*/_createTextVNode("消耗了 ")
const _hoisted_126 = /*#__PURE__*/_createTextVNode("兑换甄选好礼")
const _hoisted_127 = { key: 1 }
const _hoisted_128 = { key: 2 }
const _hoisted_129 = /*#__PURE__*/_createTextVNode("消耗 ")
const _hoisted_130 = /*#__PURE__*/_createTextVNode("参与兑换。")
const _hoisted_131 = {
  key: 8,
  class: "swiper-slide"
}
const _hoisted_132 = /*#__PURE__*/_createVNode("p", null, "在过去的一年里，", -1)
const _hoisted_133 = /*#__PURE__*/_createVNode("p", null, "你还没有尝试过参与互动活动", -1)
const _hoisted_134 = /*#__PURE__*/_createVNode("p", null, "我们期待明年能与你相遇", -1)
const _hoisted_135 = /*#__PURE__*/_createVNode("p", null, "总会相逢，", -1)
const _hoisted_136 = /*#__PURE__*/_createVNode("p", null, "就像山川河流，就像万河归海。", -1)
const _hoisted_137 = /*#__PURE__*/_createVNode("p", null, "这一年，", -1)
const _hoisted_138 = /*#__PURE__*/_createTextVNode("你共获得了 ")
const _hoisted_139 = /*#__PURE__*/_createTextVNode(" 积分")
const _hoisted_140 = /*#__PURE__*/_createVNode("p", null, "但", -1)
const _hoisted_141 = /*#__PURE__*/_createVNode("p", null, "别忘了，生活既有诗和远方，", -1)
const _hoisted_142 = /*#__PURE__*/_createVNode("p", null, "也有积分商城为你甄选的惊喜！", -1)
const _hoisted_143 = {
  key: 9,
  class: "swiper-slide"
}
const _hoisted_144 = /*#__PURE__*/_createTextVNode("从")
const _hoisted_145 = /*#__PURE__*/_createTextVNode("年")
const _hoisted_146 = /*#__PURE__*/_createTextVNode("月")
const _hoisted_147 = /*#__PURE__*/_createTextVNode("日")
const _hoisted_148 = /*#__PURE__*/_createVNode("p", null, "到2023年12月，", -1)
const _hoisted_149 = /*#__PURE__*/_createVNode("p", null, "在时间长河里", -1)
const _hoisted_150 = /*#__PURE__*/_createVNode("p", null, "每一次旅途都是一帧不可复刻的电影", -1)
const _hoisted_151 = /*#__PURE__*/_createVNode("p", null, "每一次陪伴，都是给彼此最好的礼物", -1)
const _hoisted_152 = /*#__PURE__*/_createVNode("p", null, "星河流转，封面小舟将带你穿越2023", -1)
const _hoisted_153 = /*#__PURE__*/_createVNode("p", null, "抵达落花飘洒、诗意盎然的2024", -1)
const _hoisted_154 = /*#__PURE__*/_createVNode("p", null, "我们一起，", -1)
const _hoisted_155 = /*#__PURE__*/_createVNode("p", null, "乘“封”破浪，驶向未来吧！", -1)
const _hoisted_156 = {
  class: "swiper-slide",
  style: {"padding":"0"}
}
const _hoisted_157 = { class: "share" }
const _hoisted_158 = /*#__PURE__*/_createVNode("img", {
  src: _imports_7,
  class: "seal",
  alt: ""
}, null, -1)
const _hoisted_159 = { class: "share-btn" }
const _hoisted_160 = /*#__PURE__*/_createVNode("div", { class: "share-tip" }, "Tips:完成分享可获得专属抽奖机会噢~", -1)
const _hoisted_161 = {
  key: 0,
  class: "share-text"
}
const _hoisted_162 = /*#__PURE__*/_createTextVNode("你好，乘客")
const _hoisted_163 = /*#__PURE__*/_createTextVNode("今天是封面新闻与你相伴的")
const _hoisted_164 = /*#__PURE__*/_createVNode("p", null, "过去的2023年，", -1)
const _hoisted_165 = /*#__PURE__*/_createTextVNode("封面新闻陪你度过了")
const _hoisted_166 = /*#__PURE__*/_createTextVNode("你打开了封面新闻")
const _hoisted_167 = /*#__PURE__*/_createTextVNode("阅读了")
const _hoisted_168 = /*#__PURE__*/_createTextVNode("你对世界的好奇心")
const _hoisted_169 = /*#__PURE__*/_createTextVNode("的封面网友")
const _hoisted_170 = {
  key: 1,
  class: "share-text"
}
const _hoisted_171 = /*#__PURE__*/_createTextVNode("你好，乘客")
const _hoisted_172 = { key: 0 }
const _hoisted_173 = /*#__PURE__*/_createTextVNode("今天是封面新闻与你相伴的")
const _hoisted_174 = { key: 1 }
const _hoisted_175 = /*#__PURE__*/_createVNode("p", null, "每一次旅途都是一帧不可复刻的电影", -1)
const _hoisted_176 = { key: 2 }
const _hoisted_177 = { key: 3 }
const _hoisted_178 = /*#__PURE__*/_createVNode("p", null, "欢迎和我一起搭乘封面小舟", -1)
const _hoisted_179 = /*#__PURE__*/_createVNode("p", null, "抵达落花飘洒、诗意盎然的2024", -1)
const _hoisted_180 = /*#__PURE__*/_createVNode("p", null, "我们一起乘“封”破浪", -1)
const _hoisted_181 = /*#__PURE__*/_createVNode("p", null, "驶向未来吧", -1)
const _hoisted_182 = {
  key: 2,
  class: "share-care"
}
const _hoisted_183 = {
  key: 0,
  src: _imports_10,
  alt: "陪伴"
}
const _hoisted_184 = {
  key: 1,
  src: _imports_11,
  alt: "沟通"
}
const _hoisted_185 = {
  key: 2,
  src: _imports_12,
  alt: "分享"
}
const _hoisted_186 = {
  key: 3,
  src: _imports_13,
  alt: "聆听"
}
const _hoisted_187 = {
  key: 0,
  class: "page-arrow"
}
const _hoisted_188 = /*#__PURE__*/_createTextVNode(" 滑动翻页 ")
const _hoisted_189 = /*#__PURE__*/_createVNode("img", {
  src: _imports_14,
  alt: ""
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.pageIndex === 0)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createVNode("img", {
            src: _imports_2,
            class: ["start", _ctx.agree ? 'agree-hover' : ''],
            alt: "开始回顾",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleStart && _ctx.handleStart(...args)))
          }, null, 2),
          _createVNode("div", {
            class: "agree",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleAgree && _ctx.handleAgree(...args)))
          }, [
            _createVNode("img", {
              src: _imports_3,
              class: _ctx.agree ? 'agree-hover' : '',
              alt: ""
            }, null, 2),
            _hoisted_5
          ]),
          _hoisted_6
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("div", null, [
      _hoisted_7,
      _hoisted_8,
      _createVNode("div", _hoisted_9, null, 512),
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          (_ctx.info.join_days)
            ? (_openBlock(), _createBlock("div", _hoisted_12, [
                _createVNode("div", null, [
                  _createVNode("p", null, [
                    _hoisted_13,
                    _createVNode("span", null, "@" + _toDisplayString(_ctx.userInfo.nickname || '封面新闻用户'), 1),
                    _hoisted_14
                  ]),
                  _createVNode("p", null, [
                    _hoisted_15,
                    _createVNode("span", null, _toDisplayString(_ctx.info.join_days), 1),
                    _hoisted_16
                  ]),
                  (_ctx.info.open_app_cnt)
                    ? (_openBlock(), _createBlock("p", _hoisted_17, [
                        _createVNode("span", null, _toDisplayString(_ctx.$moment(_ctx.info.view_date_first).format('YYYY')), 1),
                        _hoisted_18,
                        _createVNode("span", null, _toDisplayString(_ctx.$moment(_ctx.info.view_date_first).format('M')), 1),
                        _hoisted_19,
                        _createVNode("span", null, _toDisplayString(_ctx.$moment(_ctx.info.view_date_first).format('D')), 1),
                        _hoisted_20
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.info.open_app_cnt)
                    ? (_openBlock(), _createBlock("p", _hoisted_21, [
                        _hoisted_22,
                        _hoisted_23,
                        _hoisted_24
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.info.open_app_cnt)
                    ? (_openBlock(), _createBlock("p", _hoisted_25, [
                        _hoisted_26,
                        _createVNode("span", null, _toDisplayString(_ctx.info.title_first), 1),
                        _hoisted_27
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.info.open_app_cnt)
                    ? (_openBlock(), _createBlock("p", _hoisted_28, "你还记得吗？"))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.info.open_app_cnt)
            ? (_openBlock(), _createBlock("div", _hoisted_29, [
                _createVNode("div", null, [
                  _hoisted_30,
                  _createVNode("p", null, [
                    _hoisted_31,
                    _createVNode("span", null, _toDisplayString(_ctx.info.open_app_days), 1),
                    _hoisted_32
                  ]),
                  _hoisted_33,
                  _createVNode("p", null, [
                    _hoisted_34,
                    _createVNode("span", null, _toDisplayString(_ctx.info.open_app_cnt), 1),
                    _hoisted_35
                  ]),
                  _hoisted_36,
                  _createVNode("p", null, [
                    _hoisted_37,
                    _createVNode("span", null, _toDisplayString(_ctx.info.rank) + "%", 1),
                    _hoisted_38
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_39, [
            _withDirectives(_createVNode("div", null, [
              _hoisted_40,
              _hoisted_41,
              _createVNode("p", null, [
                _createVNode("span", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleOpenNews(10286, 30)))
                }, "《寻路东坡—大型人文采访活动》")
              ]),
              _createVNode("p", null, [
                _createVNode("img", {
                  src: "https://yunyingcdn.thecover.cn/o_1hheiveie14c418o114s5rtd1imq9.jpg",
                  class: "news-img",
                  alt: "《寻路东坡—大型人文采访活动》",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleOpenNews(10286, 30)))
                })
              ])
            ], 512), [
              [_vShow, _ctx.isInitSwiper]
            ])
          ]),
          _createVNode("div", _hoisted_42, [
            _withDirectives(_createVNode("div", null, [
              _hoisted_43,
              _hoisted_44,
              _createVNode("p", null, [
                _createVNode("span", {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleOpenNews(11323, 30)))
                }, "《九路记者穿越千年足迹 探索古今蜀道的变与不变》")
              ]),
              _createVNode("p", null, [
                _createVNode("img", {
                  src: "https://yunyingcdn.thecover.cn/o_1hhjnjod5afrvgnda11628ur2e.jpg",
                  class: "news-img",
                  alt: "《九路记者穿越千年足迹 探索古今蜀道的变与不变》",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleOpenNews(11323, 30)))
                })
              ])
            ], 512), [
              [_vShow, _ctx.isInitSwiper]
            ])
          ]),
          _createVNode("div", _hoisted_45, [
            _withDirectives(_createVNode("div", null, [
              _hoisted_46,
              _hoisted_47,
              _createVNode("p", null, [
                _createVNode("span", {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleOpenNews(10696, 30)))
                }, "《天涯共此时 大运火炬同框超级月亮》")
              ]),
              _createVNode("p", null, [
                _createVNode("img", {
                  src: "https://yunyingcdn.thecover.cn/o_1hhjnm37osutctu15pn522jp3j.jpg",
                  class: "news-img",
                  alt: "《天涯共此时 大运火炬同框超级月亮》",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleOpenNews(10696, 30)))
                })
              ])
            ], 512), [
              [_vShow, _ctx.isInitSwiper]
            ])
          ]),
          _createVNode("div", _hoisted_48, [
            _withDirectives(_createVNode("div", null, [
              _hoisted_49,
              _hoisted_50,
              _createVNode("p", null, [
                _createVNode("span", {
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleOpenNews(10878121 , 1)))
                }, "《蜀道翠云 两千年见树如面｜XR沉浸式新闻情景短剧》")
              ]),
              _createVNode("p", null, [
                _createVNode("img", {
                  src: "https://yunyingcdn.thecover.cn/o_1hhjnp76gl331iqb5v8d0l14fbt.jpg",
                  class: "news-img",
                  alt: "《蜀道翠云 两千年见树如面｜XR沉浸式新闻情景短剧》",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleOpenNews(10878121, 1)))
                })
              ])
            ], 512), [
              [_vShow, _ctx.isInitSwiper]
            ])
          ]),
          _createVNode("div", _hoisted_51, [
            _withDirectives(_createVNode("div", null, [
              _hoisted_52,
              _hoisted_53,
              _createVNode("p", null, [
                _createVNode("span", {
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleOpenNews(11487, 13)))
                }, "《凉山、攀枝花石榴“卖惨带货”现象调查：视频全是摆拍，主播给钱找村民当演员》")
              ]),
              _createVNode("p", null, [
                _createVNode("img", {
                  src: "https://yunyingcdn.thecover.cn/o_1hhjnro9k8pk1d4n1o2h1q791job12.jpg",
                  class: "news-img",
                  alt: "《凉山、攀枝花石榴“卖惨带货”现象调查：视频全是摆拍，主播给钱找村民当演员》",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleOpenNews(11487, 13)))
                })
              ])
            ], 512), [
              [_vShow, _ctx.isInitSwiper]
            ])
          ]),
          (_ctx.info.open_app_cnt)
            ? (_openBlock(), _createBlock("div", _hoisted_54, [
                _createVNode("div", null, [
                  _hoisted_55,
                  _hoisted_56,
                  (_ctx.info.news_read_cnt)
                    ? (_openBlock(), _createBlock("p", _hoisted_57, [
                        _hoisted_58,
                        _createVNode("span", null, _toDisplayString(_ctx.info.news_read_cnt), 1),
                        _hoisted_59
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.info.live_read_cnt)
                    ? (_openBlock(), _createBlock("p", _hoisted_60, [
                        _hoisted_61,
                        _createVNode("span", null, _toDisplayString(_ctx.info.live_read_cnt), 1),
                        _hoisted_62
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.info.share_cnt)
                    ? (_openBlock(), _createBlock("p", _hoisted_63, [
                        _hoisted_64,
                        _createVNode("span", null, _toDisplayString(_ctx.info.share_cnt), 1),
                        _hoisted_65
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.info.like_cnt)
                    ? (_openBlock(), _createBlock("p", _hoisted_66, [
                        _hoisted_67,
                        _createVNode("span", null, _toDisplayString(_ctx.info.like_cnt), 1),
                        _hoisted_68
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.info.dynamic_pub_cnt)
                    ? (_openBlock(), _createBlock("p", _hoisted_69, [
                        _hoisted_70,
                        _createVNode("span", null, _toDisplayString(_ctx.info.dynamic_pub_cnt), 1),
                        _hoisted_71
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.info.discuss_cms_cnt)
                    ? (_openBlock(), _createBlock("p", _hoisted_72, [
                        _hoisted_73,
                        _createVNode("span", null, _toDisplayString(_ctx.info.discuss_cms_cnt), 1),
                        _hoisted_74
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.info.follow_cnt && _ctx.info.praise_cnt)
                    ? (_openBlock(), _createBlock("p", _hoisted_75, [
                        _hoisted_76,
                        _createVNode("span", null, _toDisplayString(_ctx.info.follow_cnt), 1),
                        _hoisted_77,
                        _createVNode("span", null, _toDisplayString(_ctx.info.praise_cnt), 1),
                        _hoisted_78
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.info.open_app_cnt && _ctx.info.channel_label && _ctx.info.channel && _ctx.info.channel.length)
            ? (_openBlock(), _createBlock("div", _hoisted_79, [
                _createVNode("div", null, [
                  _hoisted_80,
                  _createVNode("div", _hoisted_81, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.info.channel, (item, index) => {
                      return (_openBlock(), _createBlock("div", {
                        style: `animation-delay: ${ index * 1 + 1 }s;`
                      }, _toDisplayString(item), 5))
                    }), 256))
                  ]),
                  _hoisted_82,
                  _hoisted_83,
                  _hoisted_84
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.info.open_app_cnt)
            ? (_openBlock(), _createBlock("div", _hoisted_85, [
                _createVNode("div", null, [
                  _hoisted_86,
                  _hoisted_87,
                  _createVNode("div", _hoisted_88, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.userTop.split(','), (item, index) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "item",
                        style: `animation-delay: ${ index * 0.3 + 3 }s;`
                      }, [
                        _hoisted_89,
                        _createTextVNode(" " + _toDisplayString(item), 1)
                      ], 4))
                    }), 256))
                  ]),
                  _hoisted_90
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.info.open_app_cnt)
            ? (_openBlock(), _createBlock("div", _hoisted_91, [
                _createVNode("div", null, [
                  _createVNode("p", null, [
                    _hoisted_92,
                    _createVNode("span", null, _toDisplayString(_ctx.info.hour_num) + "%", 1),
                    _hoisted_93
                  ]),
                  _hoisted_94,
                  _createVNode("p", null, [
                    _createVNode("span", null, _toDisplayString(_ctx.hour_text(_ctx.info.hour_num)) + "时段", 1)
                  ]),
                  _hoisted_95,
                  _hoisted_96,
                  _createVNode("p", null, [
                    _createVNode("span", null, _toDisplayString(_ctx.hour_text(_ctx.info.hour_num)) + "的你：", 1)
                  ]),
                  (_ctx.info.hour_num === 26)
                    ? (_openBlock(), _createBlock("p", _hoisted_97, "在人潮熙攘的通勤路上，"))
                    : _createCommentVNode("", true),
                  (_ctx.info.hour_num === 26)
                    ? (_openBlock(), _createBlock("p", _hoisted_98, "打开封面早报，"))
                    : _createCommentVNode("", true),
                  (_ctx.info.hour_num === 26)
                    ? (_openBlock(), _createBlock("p", _hoisted_99, "让我们陪你开启全新的每一天吧。"))
                    : _createCommentVNode("", true),
                  (_ctx.info.hour_num === 42)
                    ? (_openBlock(), _createBlock("p", _hoisted_100, "灵感枯竭想放松？"))
                    : _createCommentVNode("", true),
                  (_ctx.info.hour_num === 42)
                    ? (_openBlock(), _createBlock("p", _hoisted_101, "打开青蕉圈子，"))
                    : _createCommentVNode("", true),
                  (_ctx.info.hour_num === 42)
                    ? (_openBlock(), _createBlock("p", _hoisted_102, "总有聊不完的话题，逛不腻的圈子。"))
                    : _createCommentVNode("", true),
                  (_ctx.info.hour_num === 21)
                    ? (_openBlock(), _createBlock("p", _hoisted_103, "更专业，更新鲜。"))
                    : _createCommentVNode("", true),
                  (_ctx.info.hour_num === 21)
                    ? (_openBlock(), _createBlock("p", _hoisted_104, "我能想到最惬意的事，"))
                    : _createCommentVNode("", true),
                  (_ctx.info.hour_num === 21)
                    ? (_openBlock(), _createBlock("p", _hoisted_105, "就是窝在沙发上刷刷云视听。"))
                    : _createCommentVNode("", true),
                  (_ctx.info.hour_num === 11)
                    ? (_openBlock(), _createBlock("p", _hoisted_106, "在闪耀星空的寂静里，"))
                    : _createCommentVNode("", true),
                  (_ctx.info.hour_num === 11)
                    ? (_openBlock(), _createBlock("p", _hoisted_107, "打开听封，"))
                    : _createCommentVNode("", true),
                  (_ctx.info.hour_num === 11)
                    ? (_openBlock(), _createBlock("p", _hoisted_108, "一起穿越夜空抵达心中的远方吧。"))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.info.open_app_cnt)
            ? (_openBlock(), _createBlock("div", _hoisted_109, [
                _createVNode("div", null, [
                  _createVNode("p", null, [
                    _createVNode("span", null, _toDisplayString(_ctx.$moment(_ctx.info.use_time_early).format('YYYY年M月D日 H点m分')), 1)
                  ]),
                  _hoisted_110,
                  _hoisted_111,
                  _hoisted_112,
                  _createVNode("p", null, [
                    (!_ctx.isNight)
                      ? (_openBlock(), _createBlock("span", _hoisted_113, _toDisplayString(_ctx.$moment(_ctx.info.use_time_lately).format('YYYY年M月D日 H点m分')), 1))
                      : _createCommentVNode("", true),
                    (_ctx.isNight)
                      ? (_openBlock(), _createBlock("span", _hoisted_114, _toDisplayString(_ctx.$moment(_ctx.info.use_time_lately).format('YYYY年M月D日 深夜H点m分')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_115,
                  _hoisted_116
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.info.open_app_cnt && _ctx.info.score_num && _ctx.info.enjoy_party_times)
            ? (_openBlock(), _createBlock("div", _hoisted_117, [
                _createVNode("div", null, [
                  _hoisted_118,
                  _createVNode("p", null, [
                    _hoisted_119,
                    _createVNode("span", null, _toDisplayString(_ctx.info.enjoy_party_times), 1),
                    _hoisted_120
                  ]),
                  _hoisted_121,
                  _hoisted_122,
                  _createVNode("p", null, [
                    _hoisted_123,
                    _createVNode("span", null, _toDisplayString(_ctx.info.score_num) + " 积分", 1)
                  ]),
                  (_ctx.info.exchange_score_num)
                    ? (_openBlock(), _createBlock("p", _hoisted_124, [
                        _hoisted_125,
                        _createVNode("span", null, _toDisplayString(Math.abs(_ctx.info.exchange_score_num)) + " 积分", 1),
                        _hoisted_126
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.info.exchange_score_num)
                    ? (_openBlock(), _createBlock("p", _hoisted_127, "更曾“一掷千金”，为了心中所好，"))
                    : _createCommentVNode("", true),
                  (_ctx.info.use_credits)
                    ? (_openBlock(), _createBlock("p", _hoisted_128, [
                        _hoisted_129,
                        _createVNode("span", null, _toDisplayString(Math.abs(_ctx.info.use_credits)) + " 积分", 1),
                        _hoisted_130
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.info.open_app_cnt && !_ctx.info.enjoy_party_times)
            ? (_openBlock(), _createBlock("div", _hoisted_131, [
                _createVNode("div", null, [
                  _hoisted_132,
                  _hoisted_133,
                  _hoisted_134,
                  _hoisted_135,
                  _hoisted_136,
                  _hoisted_137,
                  _createVNode("p", null, [
                    _hoisted_138,
                    _createVNode("span", null, _toDisplayString(Math.abs(_ctx.info.score_num)), 1),
                    _hoisted_139
                  ]),
                  _hoisted_140,
                  _hoisted_141,
                  _hoisted_142
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.info.open_app_cnt)
            ? (_openBlock(), _createBlock("div", _hoisted_143, [
                _createVNode("div", null, [
                  _createVNode("p", null, [
                    _hoisted_144,
                    _createVNode("span", null, _toDisplayString(_ctx.$moment(_ctx.info.view_date_first).format('YYYY')), 1),
                    _hoisted_145,
                    _createVNode("span", null, _toDisplayString(_ctx.$moment(_ctx.info.view_date_first).format('M')), 1),
                    _hoisted_146,
                    _createVNode("span", null, _toDisplayString(_ctx.$moment(_ctx.info.view_date_first).format('D')), 1),
                    _hoisted_147
                  ]),
                  _hoisted_148,
                  _hoisted_149,
                  _hoisted_150,
                  _hoisted_151,
                  _hoisted_152,
                  _hoisted_153,
                  _hoisted_154,
                  _hoisted_155
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_156, [
            _withDirectives(_createVNode("div", _hoisted_157, [
              _hoisted_158,
              _createVNode("div", _hoisted_159, [
                _createVNode("img", {
                  src: _imports_8,
                  alt: "重温2023",
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.handleReload && _ctx.handleReload(...args)))
                }),
                _createVNode("img", {
                  src: _imports_9,
                  alt: "分享船票",
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.handleSharePoster && _ctx.handleSharePoster(...args)))
                })
              ]),
              _hoisted_160,
              (_ctx.info.open_app_cnt)
                ? (_openBlock(), _createBlock("div", _hoisted_161, [
                    _createVNode("p", null, [
                      _hoisted_162,
                      _createVNode("span", null, _toDisplayString(_ctx.userInfo.nickname || '封面新闻用户'), 1)
                    ]),
                    _createVNode("p", null, [
                      _hoisted_163,
                      _createVNode("span", null, "第" + _toDisplayString(_ctx.info.join_days) + "天", 1)
                    ]),
                    _hoisted_164,
                    _createVNode("p", null, [
                      _hoisted_165,
                      _createVNode("span", null, _toDisplayString(_ctx.info.open_app_days) + "天", 1)
                    ]),
                    _createVNode("p", null, [
                      _hoisted_166,
                      _createVNode("span", null, _toDisplayString(_ctx.info.open_app_cnt) + "次", 1)
                    ]),
                    _createVNode("p", null, [
                      _hoisted_167,
                      _createVNode("span", null, _toDisplayString(_ctx.info.news_read_cnt) + "篇新闻", 1)
                    ]),
                    _createVNode("p", null, [
                      _hoisted_168,
                      _createVNode("span", null, "超过了" + _toDisplayString(_ctx.info.rank) + "%", 1),
                      _hoisted_169
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.info.open_app_cnt)
                ? (_openBlock(), _createBlock("div", _hoisted_170, [
                    _createVNode("p", null, [
                      _hoisted_171,
                      _createVNode("span", null, _toDisplayString(_ctx.userInfo.nickname || '封面新闻用户'), 1)
                    ]),
                    (_ctx.info.join_days)
                      ? (_openBlock(), _createBlock("p", _hoisted_172, [
                          _hoisted_173,
                          _createVNode("span", null, "第" + _toDisplayString(_ctx.info.join_days) + "天", 1)
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.info.join_days)
                      ? (_openBlock(), _createBlock("p", _hoisted_174, "在时间长河里"))
                      : _createCommentVNode("", true),
                    _hoisted_175,
                    (_ctx.info.join_days)
                      ? (_openBlock(), _createBlock("p", _hoisted_176, "每一次重逢，都是给彼此最好的礼物"))
                      : _createCommentVNode("", true),
                    (!_ctx.info.join_days)
                      ? (_openBlock(), _createBlock("p", _hoisted_177, "每一次相遇，都是给彼此最好的礼物"))
                      : _createCommentVNode("", true),
                    _hoisted_178,
                    _hoisted_179,
                    _hoisted_180,
                    _hoisted_181
                  ]))
                : _createCommentVNode("", true),
              (_ctx.info.open_app_cnt)
                ? (_openBlock(), _createBlock("div", _hoisted_182, [
                    (_ctx.care === 1)
                      ? (_openBlock(), _createBlock("img", _hoisted_183))
                      : _createCommentVNode("", true),
                    (_ctx.care === 2)
                      ? (_openBlock(), _createBlock("img", _hoisted_184))
                      : _createCommentVNode("", true),
                    (_ctx.care === 3)
                      ? (_openBlock(), _createBlock("img", _hoisted_185))
                      : _createCommentVNode("", true),
                    (_ctx.care === 4)
                      ? (_openBlock(), _createBlock("img", _hoisted_186))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 512), [
              [_vShow, _ctx.isInitSwiper]
            ])
          ])
        ])
      ]),
      (_ctx.pageIndex === 1)
        ? (_openBlock(), _createBlock("div", _hoisted_187, [
            _hoisted_188,
            _hoisted_189
          ]))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, _ctx.pageIndex >= 1]
    ])
  ]))
})